import { REQUEST_STATUS } from '@/constants/request-status'

export function canManagerPerformReviewActions(
  requestStatusId: string
): boolean {
  return requestStatusId === REQUEST_STATUS.UNDER_REVIEW.id
}
